<template>
  <div class="form-box" :class="{ 'formbox-other': otherLogin }" @click.stop>
    <div class="type-title" v-if="!otherLogin && !findPassword && !wxLogin">
      <span
        :class="{ current: codeLogin }"
        @click="
          codeLogin = true;
          resetForm('loginInfo');
        "
      >
        验证码登录
      </span>
      <span
        :class="{ current: !codeLogin }"
        @click="
          codeLogin = false;
          resetForm('loginInfo');
        "
      >
        密码登录
      </span>
    </div>
    <div class="type-title type-title-forget" v-if="findPassword">
      <span class="primary-color">忘记密码</span>
    </div>
    <div class="type-title type-title-other" v-if="otherLogin">
      <span class="primary-color">绑定手机号</span>
    </div>
    <el-form
      class="form-code-password-login"
      :class="{ 'form-code-login': codeLogin }"
      v-show="!otherLogin && !findPassword && !wxLogin"
      :model="loginInfo"
      :rules="rules"
      ref="loginInfo"
      :hide-required-asterisk="true"
      :validate-on-rule-change="false"
    >
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input
          placeholder="请输入手机号"
          v-model="loginInfo.phone"
          @focus="onInputFocus"
          @blur="onInputBlur"
          maxlength="11"
        >
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="codeLogin" class="el-form-item-code">
        <div class="label">验证码</div>
        <el-input
          placeholder="请输入验证码"
          v-model="loginInfo.code"
          @keydown.native.enter="submitForm()"
          @focus="onInputFocus"
          @blur="onInputBlur"
        ></el-input>
        <el-button
          class="btn-code"
          :disabled="codeBtn"
          type="text"
          @click="get_code('loginInfo', 'login', loginInfo.phone)"
        >
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>

      <el-form-item
        prop="password"
        class="el-form-item-password"
        v-if="!codeLogin"
      >
        <div class="label">密码</div>
        <el-password
          v-model="loginInfo.password"
          @enter="submitForm()"
        ></el-password>
        <el-button
          class="btn-forget"
          type="text"
          v-if="!codeLogin"
          @click="forget_password"
        >
          忘记密码?
        </el-button>
      </el-form-item>
      <el-form-item
        v-if="pcLoginCount > 3"
        prop="captcha"
        class="code el-form-item__img-code"
      >
        <el-input
          placeholder="请输入图形验证码"
          v-model="loginInfo.captcha"
          @keydown.native.enter="submitForm()"
          @focus="onInputFocus"
          @blur="onInputBlur"
          maxlength="6"
        ></el-input>
        <img
          :src="img_code"
          class="img_code"
          @click="getImgCode"
          title="点击切换验证码"
        />
        <img
          class="img-refresh"
          src="@/assets/images/common/refresh@2x.png"
          @click="getImgCode"
        />
        <a class="lnk-refresh" @click="getImgCode">刷新</a>
      </el-form-item>
      <div
        v-if="
          codeLogin && $store.state.commonSetting.allow_student_register == 1
        "
        class="code-login-tip"
      >
        未注册的手机号登录时将自动注册
      </div>
      <el-form-item class="submit">
        <div class="btn-login" @click="submitForm()">登录</div>
      </el-form-item>
    </el-form>
    <el-form
      v-if="otherLogin"
      :model="otherLoginInfo"
      :rules="otherLoginRules"
      ref="otherLoginInfo"
      class="other-login"
      :hide-required-asterisk="true"
      :validate-on-rule-change="false"
    >
      <div class="other-login-tip">
        请绑定手机号，便于后续给您发送上课提醒短信，以免错过课程
      </div>
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input
          placeholder="请输入手机号"
          v-model="otherLoginInfo.phone"
          @focus="onInputFocus"
          @blur="onInputBlur"
          maxlength="11"
        >
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item class="el-form-item-code" prop="code">
        <div class="label">验证码</div>
        <el-input
          placeholder="请输入验证码"
          v-model="otherLoginInfo.code"
          @focus="onInputFocus"
          @blur="onInputBlur"
        ></el-input>
        <el-button
          class="btn-code"
          :disabled="codeBtn"
          type="text"
          @click="
            get_code('otherLoginInfo', 'loginOauth', otherLoginInfo.phone)
          "
        >
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>
      <el-form-item class="submit">
        <div class="btn-login" @click="otherSubmitForm()">确定</div>
      </el-form-item>
    </el-form>
    <el-form
      v-show="findPassword"
      :model="otherLoginInfo"
      :rules="otherLoginRules"
      ref="findPasswordInfo"
      :hide-required-asterisk="true"
      class="find-password"
      :validate-on-rule-change="false"
    >
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input
          placeholder="请输入手机号"
          v-model="otherLoginInfo.phone"
          @focus="onInputFocus"
          @blur="onInputBlur"
        >
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="label">验证码</div>
        <el-input
          placeholder="请输入验证码"
          v-model="otherLoginInfo.code"
          @focus="onInputFocus"
          @blur="onInputBlur"
        ></el-input>
        <el-button
          class="btn-code"
          :disabled="codeBtn"
          type="text"
          @click="
            get_code('findPasswordInfo', 'getPassword', otherLoginInfo.phone)
          "
        >
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>
      <el-form-item class="el-form-item-password" prop="password">
        <div class="label">密码</div>
        <el-password v-model="otherLoginInfo.password"></el-password>
      </el-form-item>
      <div class="btn-login" @click="findSubmitForm()">确定</div>
      <div class="now-login" @click="nowLogin">登录</div>
    </el-form>
    <div class="other" v-if="!findPassword && !otherLogin && !wxLogin">
      <div
        class="title"
        v-if="
          oauthConfig.wxLogin.is_available == 1 ||
          oauthConfig.qqLogin.is_available == 1
        "
      >
        第三方登录
      </div>
      <div class="set">
        <img
          src="@/assets/images/login/wechat@2x.png"
          class="wechat"
          @click="wx_login_saas()"
          v-if="
            oauthConfig.wxLogin.is_available == 1 &&
            $store.state.commonSetting.saas_enable == 1
          "
        />
        <img
          src="@/assets/images/login/wechat@2x.png"
          class="wechat"
          @click="wx_login(1)"
          v-if="
            oauthConfig.wxLogin.is_available == 1 &&
            $store.state.commonSetting.saas_enable != 1
          "
        />
        <img
          src="@/assets/images/login/qq@2x.png"
          class="qq"
          @click="qq_login()"
          v-if="
            oauthConfig.qqLogin.is_available == 1 &&
            $store.state.commonSetting.is_force_bind_wx != 1
          "
        />
      </div>
      <div class="center contract">
        <span>登录即代表您同意</span>
        <a
          href="javascript:void(0)"
          @click="openContract('user_register_contract')"
        >
          《用户注册协议》
        </a>
        <span>和</span>
        <a
          href="javascript:void(0)"
          @click="openContract('user_protect_contract')"
        >
          《隐私政策》
        </a>
      </div>
    </div>
    <SelectSchoolDlg
      ref="selectSchool"
      :visible.sync="showSelectSchool"
      @on-select="onSelectSchool"
    ></SelectSchoolDlg>
    <Alert :show.sync="showNewUserAlert" @close="onNewUserClose">
      <div class="newuser-tips">
        您已注册成功，初始密码为：{{
          defaultPassword
        }}，请及时前往个人中心更换密码
      </div>
    </Alert>
    <div v-show="wxLogin" class="wx-code-box">
      <p class="title">微信{{ is_bind_wx == 1 ? "绑定" : "登录" }}</p>
      <div id="wx_login_id"></div>
      <p class="msg">请使用微信扫码{{ is_bind_wx == 1 ? "绑定" : "登录" }}</p>
      <p @click="wxLogin = false" class="back">
        <img src="~@/assets/images/login/login_code_back.png" />
        返回
      </p>
    </div>
  </div>
</template>
<script>
import SelectSchoolDlg from "./SelectSchoolDlg";
import Alert from "@/components/Alert.vue";

export default {
  name: "StudentLogin",
  components: {
    SelectSchoolDlg,
    Alert,
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (value.length < 11) {
        callback(new Error("手机号码不足11位，请重新输入！"));
      } else if (reg.test(value) === false) {
        callback(new Error("请输入正确的11位号码！"));
      } else {
        callback();
      }
    };
    let imgCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("图形验证码不能为空"));
      } else if (value.length < 4) {
        callback(new Error("图形验证码不足4位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入短信验证码"));
      } else if (value.length < 6) {
        callback(new Error("短信验证码不足6位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateRePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.passInfo.rePassword !== this.passInfo.password) {
        callback(new Error("两次输入密码不一致"));
      } else if (this.$pub.guarantee(1, this.passInfo.rePassword)) {
        if (this.$pub.guarantee(1, this.passInfo.rePassword) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, this.passInfo.rePassword)));
        }
      } else {
        callback();
      }
    };
    let RecoverPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (this.$pub.guarantee(1, value)) {
        if (this.$pub.guarantee(1, value) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, value)));
        }
      } else {
        callback();
      }
    };
    return {
      is_bind_wx: 0,
      pcLoginCount: 0,
      img_code: "",
      codeBtn: false,
      codeBtnInfo: "获取验证码",
      codeLogin: false,
      otherLogin: false,
      findPassword: false,
      loginInfo: {
        phone: "",
        password: "",
        code: "",
        captcha: "",
        key: "",
      },
      rules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
      },
      passInfo: {
        password: "",
        rePassword: "",
      },
      passRules: {
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        rePassword: [
          {
            required: true,
            validator: validateRePass,
            trigger: "blur",
          },
        ],
      },
      otherLoginInfo: {
        phone: "",
        code: "",
        password: "",
      },
      otherLoginRules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: RecoverPassword,
            trigger: "blur",
          },
        ],
      },
      openId: "",
      otherType: 1,
      oauthConfig: { qqLogin: {}, wxLogin: {} },
      showSelectSchool: false,
      showNewUserAlert: false,
      newUserResolve: null,
      defaultPassword: "",
      wxLogin: false,
    };
  },
  watch: {
    $route: {
      handler: async function () {
        this.pcLoginCount = sessionStorage.pcLoginCount;
        if (sessionStorage.pcLoginCount > 3) {
          await this.getImgCode();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    config() {
      return this.$store.state.webConfig;
    },
  },

  async getFirstLogin(mobile){
      const res = await this.$http.get("/api/app/first_login",{mobile})
      return res.is_collect==2?true:false
  },
  async created() {
    this.pcLoginCount = sessionStorage.pcLoginCount;
    if (sessionStorage.pcLoginCount > 3) {
      await this.getImgCode();
    }
    this.oauthConfig = await this.$http.put(
      "/api/app/systemSet/available/oauthConfig",
    );
    if (this.$route.query.code) {
      this.otherType = this.$route.query.state;
      let data;
      if (this.$route.query.mobile) {
        data = await this.$http.post("/api/app/login", {
          type: this.otherType,
          code: this.$route.query.code,
          mobile: this.$route.query.mobile,
        });
      } else {
        data = await this.$http.post("/api/app/login", {
          type: this.otherType,
          code: this.$route.query.code,
        });
      }

      data.need_collect_data = await this.getFirstLogin(this.$route.query.mobile)

      if (data.need_collect_data) {
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
        return;
      }
      if (data.id) {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        this.goTo();
      } else {
        this.openId = data.msg;
        this.otherLogin = true;
      }
    }
  },
  mounted: function () {
    if (this.$route.query.type == "register") {
      this.set_login_type();
    }
    this.$nextTick(() => {
      document.getElementById("app").style.height = "100%";
    });
  },
  methods: {
    onSelectSchool(school_id) {
      this.$store.commit("clearSchoolInfo");
      this.$store.commit("setSchoolID", school_id);
      if (this.otherLogin) {
        this.otherLoginFunc();
      } else {
        this.login();
      }
    },
    async getImgCode() {

        const res = await this.$http.get("/api/app/captcha", {})

        this.img_code = res.img;
        this.loginInfo.key = res.key;
    },
    onInputFocus($event) {
      let target = $event.target;
      target.parentElement.classList.add("focus");
    },
    onInputBlur($event) {
      let target = $event.target;
      target.parentElement.classList.remove("focus");
    },
    goTo() {
      this.$store.dispatch("refreshMessageState");
      if (sessionStorage.loginBack) {
        this.$router.push({
          path: sessionStorage.loginBack,
          query: sessionStorage.loginQuery
            ? JSON.parse(sessionStorage.loginQuery)
            : {},
        });
        sessionStorage.removeItem("loginBack");
        sessionStorage.removeItem("loginQuery");
      } else if (this.$route.query.relogin) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "Home" });
      }
      this.$store.commit("setCouponDlg", {
        show: true,
        type: 2,
      });
    },
    submitForm() {
      this.$refs["loginInfo"].validate(async valid => {
        if (!valid) return;
        // 密码登陆不检测用户
        // if (!this.codeLogin) {
        //   await this.login();
        // } else {
        //   const result = await this.checkUser(this.loginInfo.phone);
        //   if (result.is_new_user == 1) {
        //     if (this.$refs.selectSchool.isSingleSchool()) {
        //       this.onSelectSchool(this.$refs.selectSchool.getSingleSchoolID());
        //     } else {
        //       this.showSelectSchool = true;
        //     }
        //   } else {
        //     await this.login();
        //   }
        // }
        await this.login();
      });
    },
    set_login_type() {
      this.codeLogin = !this.codeLogin;
      this.resetForm("loginInfo");
      this.loginInfo.password = "";
      this.loginInfo.code = "";
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // async checkUser(mobile) {
    //   const data = await this.$http.get(`/api/app/checkUser/${mobile}`);
    //   return data;
    // },
    onNewUserClose() {
      this.newUserResolve();
    },
    handleNewUser(data) {
      if (!this.codeLogin) {
        return;
      }
      return new Promise(resolve => {
        if (data.first_login == 1) {
          this.defaultPassword = data.default_pass;
          this.newUserResolve = resolve;
          this.showNewUserAlert = true;
        } else {
          resolve();
        }
      });
    },
    async login() {
      let request = {
        mobile: this.loginInfo.phone,
        type: this.codeLogin ? 2 : 1,
        client: 1,
      };
      if (this.codeLogin) {
        request.sms_code = this.loginInfo.code;
      } else {
        request.password = this.loginInfo.password;
      }
      if (!sessionStorage.pcLoginCount) {
        sessionStorage.pcLoginCount = 0;
      }
      sessionStorage.pcLoginCount++;
      this.pcLoginCount = sessionStorage.pcLoginCount;
      if (sessionStorage.pcLoginCount > 3) {
        await this.getImgCode();
        request.captcha = this.loginInfo.captcha;
        request.key = this.loginInfo.key;
      }
      let data = await this.$http.post("/api/app/login", request);
      if (data.is_force_bind_wx == 1 && data.wx_openid == "") {
        this.wx_login(2);
        this.is_bind_wx = 1;
        return;
      }
      await this.handleNewUser(data);
      sessionStorage.removeItem("pcLoginCount");

      data.need_collect_data = await this.getFirstLogin(this.loginInfo.phone)

      if (data.need_collect_data) {
        sessionStorage.setItem("pr_userId", data.id);
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
      } else {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        await this.$success("登录成功");
        this.goTo();
      }
    },
    get_code(info, type, mobile) {
      this.$refs[info].validateField("phone", async validMessage => {
        if (validMessage != "") {
          return;
        }
        await this.$services.CodeService.sendSmsCode(mobile, type);
        let count = 60;
        this.codeBtn = true;
        let sendTimer = setInterval(() => {
          count--;
          this.codeBtnInfo = "重新发送" + count;
          if (count < 0) {
            this.codeBtn = false;
            clearInterval(sendTimer);
            this.codeBtnInfo = "获取验证码";
          }
        }, 1000);
      });
    },
    forget_password() {
      this.findPassword = true;
      this.resetForm("findPasswordInfo");
    },
    nowLogin() {
      this.findPassword = false;
      this.resetForm("loginInfo");
    },
    qq_login() {
      let url = location.protocol + "//" + location.host;
      document.location =
        "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=" +
        this.oauthConfig.qqLogin.appId +
        "&redirect_uri=" +
        url +
        "/login&state=3";
    },
    wx_login(type) {
      const that = this;
      let url = location.protocol + "//" + location.host + this.$route.path;
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      const wxElement = document.body.appendChild(s);
      wxElement.onload = function () {
        let obj = new window.WxLogin({
          id: "wx_login_id", // 需要显示的容器id
          appid: that.oauthConfig.wxLogin.appId, // 公众号appid wx*******
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: encodeURIComponent(
            url + (type == 2 ? "?mobile=" + that.loginInfo.phone : ""),
          ), // 授权成功后回调的url
          state: 4, // 可设置为简单的随机数加session用来校验
          style: "black", // 提供"black"、"white"可选。二维码的样式
          href:
            "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3gge3dpZHRoOjIxMnB4O2hlaWdodDoyMTJweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMTJweDtoZWlnaHQ6MjEycHg7bWFyZ2luOiAwO2JvcmRlcjogbm9uZX0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg==", // 外部css文件url，需要https
        });
        console.log(obj);
        that.wxLogin = true;
      };
    },
    wx_login_saas() {
      const that = this;
      let url = location.protocol + "//" + location.host + this.$route.path;
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      const wxElement = document.body.appendChild(s);
      wxElement.onload = function () {
        let obj = new window.WxLogin({
          id: "wx_login_id", // 需要显示的容器id
          appid: that.oauthConfig.wxLogin.appId, // 公众号appid wx*******
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: encodeURIComponent(
            that.config.login_auth_url +
              "/login-middle?saas_redirect_url=" +
              url,
          ), // 授权成功后回调的url
          state: 4, // 可设置为简单的随机数加session用来校验
          style: "black", // 提供"black"、"white"可选。二维码的样式
          href:
            "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3gge3dpZHRoOjIxMnB4O2hlaWdodDoyMTJweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMTJweDtoZWlnaHQ6MjEycHg7bWFyZ2luOiAwO2JvcmRlcjogbm9uZX0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg==", // 外部css文件url，需要https
        });
        console.log(obj);
        that.wxLogin = true;
      };
    },
    otherSubmitForm() {
      this.$refs["otherLoginInfo"].validate(async valid => {
        if (!valid) return;
        // const result = await this.checkUser(this.otherLoginInfo.phone);
        // if (result.is_new_user == 1) {
        //   if (this.$refs.selectSchool.isSingleSchool()) {
        //     this.onSelectSchool(this.$refs.selectSchool.getSingleSchoolID());
        //   } else {
        //     this.showSelectSchool = true;
        //   }
        // } else {
        //   await this.otherLoginFunc();
        // }
        await this.otherLoginFunc();
      });
    },
    async otherLoginFunc() {
      let data = await this.$http.post("/api/app/login", {
        type: this.$route.query.state,
        mobile: this.otherLoginInfo.phone,
        sms_code: this.otherLoginInfo.code,
        password: this.otherLoginInfo.password,
        unionid: this.openId,
      });
      await this.handleNewUser(data);
      sessionStorage.removeItem("pcLoginCount");
      data.need_collect_data = await this.getFirstLogin(this.otherLoginInfo.phone)

      if (data.need_collect_data) {
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
      } else {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        await this.$success("登录成功");
        this.goTo();
      }
    },
    findSubmitForm() {
      this.$refs["findPasswordInfo"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post("/api/app/password", {
          mobile: this.otherLoginInfo.phone,
          password: this.otherLoginInfo.password,
          sms_code: this.otherLoginInfo.code,
        });
        await this.$info("密码重置成功，请登录！");
        this.findPassword = false;
      });
    },
    openContract(key) {
      const { href } = this.$router.resolve({
        name: "Contract",
        query: {
          key: key,
        },
      });
      document.location = href;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/login.scss";
</style>
